import React from "react";
import {
  Users,
  Sparkles,
  UserCheck,
  UserX,
} from "lucide-react";

const defaultStats = {
  total: 0,
  new_count: 0,
  active_count: 0,
  lost_count: 0,
};

const CustomerMiniDashboard = ({ stats = defaultStats, loading }) => {
  const s = { ...defaultStats, ...stats };

  const items = [
    {
      key: "total",
      label: "Tổng số",
      shortLabel: "Tổng",
      value: s.total,
      icon: Users,
      valueClass: "text-slate-900",
      labelClass: "text-slate-700",
      iconWrapClass:
        "border border-slate-300 bg-white text-slate-800 shadow-sm",
      mobileIconWrap: "bg-slate-200 text-slate-800",
      cardClass:
        "border-slate-300 bg-gradient-to-br from-slate-200 via-slate-100 to-slate-50 shadow-slate-200/70",
      blobClass: "bg-slate-400/55",
      watermarkClass: "text-slate-500/35",
    },
    {
      key: "new",
      label: "Mới",
      shortLabel: "Mới",
      value: s.new_count,
      icon: Sparkles,
      valueClass: "text-sky-900",
      labelClass: "text-sky-800",
      iconWrapClass:
        "border border-sky-300 bg-white text-sky-800 shadow-sm",
      mobileIconWrap: "bg-sky-200 text-sky-800",
      cardClass:
        "border-sky-300 bg-gradient-to-br from-sky-200 via-sky-100 to-blue-50 shadow-sky-200/60",
      blobClass: "bg-sky-400/55",
      watermarkClass: "text-sky-600/40",
    },
    {
      key: "active",
      label: "Đang chăm sóc",
      shortLabel: "Chăm sóc",
      value: s.active_count,
      icon: UserCheck,
      valueClass: "text-emerald-900",
      labelClass: "text-emerald-800",
      iconWrapClass:
        "border border-emerald-300 bg-white text-emerald-800 shadow-sm",
      mobileIconWrap: "bg-emerald-200 text-emerald-800",
      cardClass:
        "border-emerald-300 bg-gradient-to-br from-emerald-200 via-emerald-100 to-teal-50 shadow-emerald-200/60",
      blobClass: "bg-emerald-400/55",
      watermarkClass: "text-emerald-600/40",
    },
    {
      key: "lost",
      label: "Mất khách",
      shortLabel: "Mất",
      value: s.lost_count,
      icon: UserX,
      valueClass: "text-rose-900",
      labelClass: "text-rose-800",
      iconWrapClass:
        "border border-rose-300 bg-white text-rose-800 shadow-sm",
      mobileIconWrap: "bg-rose-200 text-rose-800",
      cardClass:
        "border-rose-300 bg-gradient-to-br from-rose-200 via-rose-100 to-red-50 shadow-rose-200/60",
      blobClass: "bg-rose-400/55",
      watermarkClass: "text-rose-600/40",
    },
  ];

  return (
    <section className="mb-4 md:mb-6" aria-label="Thống kê khách hàng">
      <div className="grid grid-cols-2 gap-1.5 md:grid-cols-2 md:gap-4 xl:grid-cols-4">
        {items.map((card) => {
          const Icon = card.icon;
          return (
            <div
              key={card.key}
              title={card.label}
              className={`relative overflow-hidden rounded-xl border p-2 text-left shadow-sm md:rounded-2xl md:p-4 md:shadow-md ${card.cardClass}`}
            >
              {/* Desktop: soft blob + watermark icon */}
              <div
                aria-hidden
                className={`pointer-events-none absolute -right-8 -top-10 hidden h-28 w-28 rounded-full blur-2xl md:block ${card.blobClass}`}
              />
              <Icon
                aria-hidden
                className={`pointer-events-none absolute -bottom-3 -right-2 hidden h-24 w-24 md:block ${card.watermarkClass}`}
                strokeWidth={1.25}
              />

              {/* Mobile compact */}
              <div className="relative flex flex-col items-center justify-center gap-0.5 md:hidden">
                <div className={`rounded-lg p-1.5 ${card.mobileIconWrap}`}>
                  <Icon className="h-3.5 w-3.5" />
                </div>
                <p
                  className={`text-base font-black tabular-nums leading-none ${card.valueClass}`}
                >
                  {loading ? "–" : card.value.toLocaleString("vi-VN")}
                </p>
                <p className="truncate text-[9px] font-bold uppercase tracking-wide text-gray-400">
                  {card.shortLabel}
                </p>
              </div>

              {/* Desktop */}
              <div className="relative z-10 hidden md:block">
                <div className="flex items-start justify-between gap-3">
                  <p
                    className={`text-[11px] font-bold uppercase tracking-wider ${card.labelClass}`}
                    title={card.label}
                  >
                    {card.label}
                  </p>
                  <div className={`rounded-xl p-2 ${card.iconWrapClass}`}>
                    <Icon className="h-4 w-4" />
                  </div>
                </div>
                <p className={`mt-3 text-3xl font-black tabular-nums ${card.valueClass}`}>
                  {loading ? "–" : card.value.toLocaleString("vi-VN")}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      <p className="mt-2 hidden text-[10px] text-gray-400 md:block">
        Số liệu theo bộ lọc hiện tại và phạm vi dữ liệu của tài khoản (không phụ thuộc phân trang).
      </p>
    </section>
  );
};

export default CustomerMiniDashboard;
